module.exports = __webpack_public_path__ + "img/edit.f87efef7.svg";